export var labels = [
  'qty',
  'web_add_cart',
  '_done',
  '_webservererror'
];